import { useState } from 'react';
import './DrawingsList.css';

interface Drawing {
  id: string;
  type: string;
  title?: string;
  comment?: string;
  color?: string;
  createdAt: any;
}

interface DrawingsListProps {
  drawings: Drawing[];
  onZoomTo: (drawingId: string) => void;
  onDelete: (drawingId: string) => void;
}

const DrawingsList = ({ drawings, onZoomTo, onDelete }: DrawingsListProps) => {
  const [isOpen, setIsOpen] = useState(false);

  if (drawings.length === 0) return null;

  return (
    <div className="drawings-list">
      <button
        className="drawings-list-toggle"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? '▼' : '▶'} My Drawings ({drawings.length})
      </button>

      {isOpen && (
        <div className="drawings-list-content">
          {drawings.map((drawing) => {
            const title = drawing.title || drawing.comment || `${drawing.type} Drawing`;
            const date = drawing.createdAt?.toDate
              ? drawing.createdAt.toDate().toLocaleDateString()
              : 'Unknown date';

            return (
              <div key={drawing.id} className="drawing-list-item">
                <div className="drawing-info">
                  {drawing.color && (
                    <div
                      className="drawing-color-indicator"
                      style={{ backgroundColor: drawing.color }}
                    />
                  )}
                  <div className="drawing-details">
                    <div className="drawing-title">{title}</div>
                    <div className="drawing-meta">
                      {drawing.type} • {date}
                    </div>
                  </div>
                </div>
                <div className="drawing-actions">
                  <button
                    className="drawing-action-btn zoom-btn"
                    onClick={() => onZoomTo(drawing.id)}
                    title="Zoom to"
                  >
                    🔍
                  </button>
                  <button
                    className="drawing-action-btn delete-btn"
                    onClick={() => onDelete(drawing.id)}
                    title="Delete"
                  >
                    🗑️
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default DrawingsList;
